export enum SearchResultQueryParam {
  Search = 'search',
}
